<template>
	<Modal
		v-if="showRemoveUserModal"
		:allowClose="false"
		@modal:close="shareResumeStore.hideRemoveUserModal"
	>
		<template #body>
			<div class="won-delete-red text-2xl font-semibold">Remove access for {{ userToBeRemoved.email }}</div>
			<div class="mt-2.5 won-blue text-sm">Are you sure that you want to remove access for selected user?</div>

			<div class="flex gap-4 items-center mt-4">
				<button
					class="w-full h-9 rounded border border-won-green font-[Inter] text-sm text-won-green font-medium"
					@click="handleClose"
				>
					Cancel
				</button>

				<button
					@click="handleDelete"
					class="w-full h-9 rounded bg-won-green hover:opacity-90 font-[Inter] text-sm text-white font-medium"
				>
					Delete
				</button>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useResumeShare } from "../store/share-resume.store";

import Modal from "../components/modal.vue";

const shareResumeStore = useResumeShare();

const { showRemoveUserModal, userToBeRemoved } = storeToRefs(shareResumeStore)

const handleClose = () => {
	shareResumeStore.hideRemoveUserModal();
}

const handleDelete = () => {
	shareResumeStore.removeUserFromShareList();
}
</script>
